exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit-file-change-btn--component-wrapper[data-v-78fccdca] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-left: 10px;\n}\n.submit-file-change-btn--component-wrapper button.btn[data-v-78fccdca] {\n    white-space: nowrap;\n}\n", ""]);

// exports
